import {
    ADD_FAVOURITE_SURVEY_GROUP,
    FETCH_ALL_SURVEY_GROUP_SUCCESS,
    FILTER_SURVEY_GROUP,
    GET_ALL_SURVEY_GROUP,
    GET_UNSELECTED_ALL_SURVEY_GROUP,
    HANDLE_SURVEY_GROUP_REQUEST_CLOSE,
    HIDE_SURVEY_GROUP_LOADER,
    SHOW_SURVEY_GROUP_LOADER,
    ON_ADD_SURVEY_GROUP,
    ON_ALL_SURVEY_GROUP_SELECT,
    ON_SURVEY_GROUP_CLOSE,
    ON_SURVEY_GROUP_SELECT,
    ON_DELETE_SURVEY_GROUP,
    ON_DELETE_SELECTED_SURVEY_GROUP,
    ON_FILTER_SURVEY_GROUP_OPTION_SELECT,
    ON_SAVE_SURVEY_GROUP_SUCCESS,
    ON_TOGGLE_SURVEY_GROUP_DRAWER,
    SHOW_SURVEY_GROUP_MESSAGE,
    UPDATE_SEARCH_SURVEY_GROUP,
    ON_SURVEY_GROUP_QUESTIONS,
    CLEAR_SESSION,
} from 'constants/ActionTypes';

const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No survey groups found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All survey groups',
    allSurveyGroup: [],
    surveyGroupList: [],
    selectedSurveyGroup: null,
    selectedSurveyGroups: 0,
    addSurveyGroupState: false,
    searchSurveyGroup: '',
    surveyGroup: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case ADD_FAVOURITE_SURVEY_GROUP: {
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Survey Group removed as star' : 'Survey Group marked as star',
                showMessage: true,
                surveyGroupList: state.surveyGroupList.map((surveyGroup) => surveyGroup.id === action.payload.id ? {
                    ...surveyGroup,
                    starred: !action.payload.starred
                } : surveyGroup),
                allSurveyGroup: state.allSurveyGroup.map((surveyGroup) => surveyGroup.id === action.payload.id ? {
                    ...surveyGroup,
                    starred: !action.payload.starred
                } : surveyGroup)
            };
        }
        case FETCH_ALL_SURVEY_GROUP_SUCCESS: {
            return {
                ...state,
                loader: false,
                allSurveyGroup: action.payload,
                surveyGroupList: action.payload,
            };
        }
        case SHOW_SURVEY_GROUP_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_SURVEY_GROUP_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedSurveyGroups = 0;
            const surveyGroupList = state.surveyGroupList.map(surveyGroup => {
                if (surveyGroup.selected) {
                    selectedSurveyGroups++;
                }
                if (surveyGroup.id === action.payload.id) {
                    if (surveyGroup.selected) {
                        selectedSurveyGroups++;
                    }
                    return action.payload;
                } else {
                    return surveyGroup;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedSurveyGroups: selectedSurveyGroups,
                surveyGroupList: surveyGroupList
            };
        }
        case ON_ADD_SURVEY_GROUP: {
            return { ...state, addSurveyGroupState: true };
        }
        case ON_SURVEY_GROUP_CLOSE: {
            return { ...state, addSurveyGroupState: false };
        }
        case ON_FILTER_SURVEY_GROUP_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let surveyGroupList = [];
            switch (action.payload.name) {
                case 'All survey groups': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    surveyGroupList = state.allSurveyGroup;
                    break;
                }
                case 'Frequently accessed': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    surveyGroupList = state.allSurveyGroup.filter((surveyGroup) => surveyGroup.frequently);
                    break;
                }
                case 'Starred survey groups': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    surveyGroupList = state.allSurveyGroup.filter((surveyGroup) => surveyGroup.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, surveyGroupList, drawerState: false
            };
        }
        case ON_SAVE_SURVEY_GROUP_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Survey Group Updated Successfully',
                showMessage: true,
                surveyGroupList: action.payload,
                allSurveyGroup: action.payload,
                loader: false,
            };
        }
        case ON_DELETE_SURVEY_GROUP: {
            return {
                ...state,
                alertMessage: 'Survey Group Deleted Successfully',
                showMessage: true,
                allSurveyGroup: state.allSurveyGroup.filter((surveyGroup) => surveyGroup.id !== action.payload.id),
                surveyGroupList: state.allSurveyGroup.filter((surveyGroup) => surveyGroup.id !== action.payload.id),
            };
        }
        case ON_DELETE_SELECTED_SURVEY_GROUP: {
            const surveyGroups = state.allSurveyGroup.filter((surveyGroup) => !surveyGroup.selected);
            return {
                ...state,
                alertMessage: 'Survey Group Deleted Successfully',
                showMessage: true,
                allSurveyGroup: surveyGroups,
                surveyGroupList: surveyGroups,
                selectedSurveyGroups: 0
            };
        }
        case FILTER_SURVEY_GROUP: {
            const { filterOption } = state;
            let surveyGroupList = [];
            if (action.payload === '') {
                surveyGroupList = state.allSurveyGroup;
            } else {
                const filterSurveyGroup = state.allSurveyGroup.filter((surveyGroup) =>
                    surveyGroup.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === 'All survey groups') {
                    surveyGroupList = filterSurveyGroup;
                } else if (filterOption === 'Frequently accessed') {
                    surveyGroupList = filterSurveyGroup.filter((surveyGroup) => surveyGroup.frequently);
                } else if (filterOption === 'Starred survey groups') {
                    surveyGroupList = filterSurveyGroup.filter((surveyGroup) => surveyGroup.starred);
                }
            }
            return { ...state, surveyGroupList: surveyGroupList };
        }
        case GET_ALL_SURVEY_GROUP: {
            let surveyGroupList = state.allSurveyGroup.map((surveyGroup) => surveyGroup ? {
                ...surveyGroup,
                selected: true
            } : surveyGroup);
            return {
                ...state,
                selectedSurveyGroups: surveyGroupList.length,
                allSurveyGroup: surveyGroupList,
                surveyGroupList: surveyGroupList
            };
        }
        case GET_UNSELECTED_ALL_SURVEY_GROUP: {
            let surveyGroupList = state.allSurveyGroup.map((surveyGroup) => surveyGroup ? {
                ...surveyGroup,
                selected: false
            } : surveyGroup);
            return {
                ...state,
                selectedSurveyGroups: 0,
                allSurveyGroup: surveyGroupList,
                surveyGroupList: surveyGroupList
            };
        }
        case ON_ALL_SURVEY_GROUP_SELECT: {
            const selectAll = state.selectedSurveyGroups < state.surveyGroupList.length;
            let selectedSurveyGroups = 0;
            let surveyGroupList = [];
            if (selectAll) {
                surveyGroupList = state.allSurveyGroup.map((surveyGroup) => surveyGroup ? {
                    ...surveyGroup,
                    selected: true
                } : surveyGroup);
                selectedSurveyGroups = surveyGroupList.length;
            } else {
                surveyGroupList = state.allSurveyGroup.map((surveyGroup) => surveyGroup ? {
                    ...surveyGroup,
                    selected: true
                } : surveyGroup);
                selectedSurveyGroups = 0;
            }
            return {
                ...state,
                selectedSurveyGroups: selectedSurveyGroups,
                allSurveyGroup: surveyGroupList,
                surveyGroupList: surveyGroupList
            };
        }
        case UPDATE_SEARCH_SURVEY_GROUP: {
            return { ...state, searchSurveyGroup: action.payload };
        }
        case HANDLE_SURVEY_GROUP_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_SURVEY_GROUP_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_SURVEY_GROUP_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_SURVEY_GROUP_LOADER: {
            return { ...state, loader: false };
        }
        case ON_SURVEY_GROUP_QUESTIONS: {
            return { ...state, loader: false, selectedSurveyGroup: action.payload };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/SurveyGroup.js